import React from "react";
import { connect } from "react-redux";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Button from "../shared/button/Button";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  CloseButton,
  ButtonsWrapper,
} from "./styles/about-agent-modal-styles";

export const AboutCompanyModal = ({
  aboutCompany,
  toggleAboutCompanyModal,
  user,
}) => (
  <Backdrop className="animated fadeIn">
    <ModalWrapper className="animated delay-1 fadeInDown">
      <Title>
        <TitleText>About {user.companyName}</TitleText>
        <CloseButton onClick={() => toggleAboutCompanyModal()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Title>
      <Body>{Parser(aboutCompany)}</Body>
      <ButtonsWrapper>
        <Button
          primary
          buttonName="Close"
          onClickAction={() => toggleAboutCompanyModal()}
        />
      </ButtonsWrapper>
    </ModalWrapper>
  </Backdrop>
);

AboutCompanyModal.propTypes = {
  aboutCompany: PropTypes.string.isRequired,
  toggleAboutCompanyModal: PropTypes.func.isRequired,
  user: PropTypes.shape({
    companyName: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  aboutCompany: state.agencyProfile.profileData.aboutCompany,
  user: state.agencyProfile.profileData.user,
});

export default connect(mapStateToProps, {})(AboutCompanyModal);
